/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceFilterPolicyResponse {
    getFixupPrototypeFunction() { return ComplianceFilterPolicyResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceFilterPolicyResponse>): ComplianceFilterPolicyResponse {
        let obj = Object.assign(new ComplianceFilterPolicyResponse(), model);
        ComplianceFilterPolicyResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceFilterPolicyResponse>): ComplianceFilterPolicyResponse {
        if (!model) return null;
        return ComplianceFilterPolicyResponse.newInstance(<ComplianceFilterPolicyResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceFilterPolicyResponse) {
        if (!obj) return;

        models.ComplianceFilterPolicyResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceFilterPolicyResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceFilterPolicyResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * success
     */
    status: string;

    /**
     * Compliance Posture Policies list
     */
    message: string;

    /**
     * data for Compliance Posture Policies list
     */
    data: any;

}
